import i18next from 'i18next';

const translator = i18next as unknown as {
   t: (key: string, options?: Record<string, unknown>) => string;
};

export const translate = (key: string, options?: Record<string, unknown>) =>
   translator.t(key, options);
